module.exports = __webpack_public_path__ + "static/media/border.52fb115b.png";